// Пометка «Замещаете: {роль} до {дата}» (contracts/ui.md, «Каркас»; spec, сценарий 6.1):
// в шапке листа, до 640 px — полосой под шапкой. Ведёт в профиль, где видны роли и замещения.
import { roleInfo } from '@kp/contracts';
import type { MeResponse } from '@kp/contracts';
import { Icon, cx } from '@kp/ui';
import { Repeat2 } from '@kp/ui/icons';
import { Link } from '@tanstack/react-router';
import { formatDate } from '../app/format.ts';
import { useMe } from './session.ts';

/** «Замещаете: контролёр до 31.10.2026»; несколько ролей — через запятую. Нет замещений — null. */
export function substitutionMarkText(roles: MeResponse['roles']): string | null {
  const parts = roles
    .filter((item) => item.substitutesFor !== undefined && item.validTo !== undefined)
    .map((item) => `${roleInfo[item.role].inText} до ${formatDate(item.validTo ?? '')}`)
    .filter((part, index, list) => list.indexOf(part) === index);
  return parts.length > 0 ? `Замещаете: ${parts.join(', ')}` : null;
}

export function SubstitutionMark({ variant }: { variant: 'topbar' | 'bar' }) {
  const text = substitutionMarkText(useMe().roles);
  if (!text) return null;
  return (
    <Link
      to="/profile"
      className={cx(variant === 'bar' ? 'kp-subst-bar' : 't-badge accent kp-subst-mark')}
    >
      <Icon icon={Repeat2} />
      <span>{text}</span>
    </Link>
  );
}
